import DocumentsManger  from "./DocumentsManger"

export default DocumentsManger;